module.exports = __webpack_public_path__ + "img/3.88ad5cdc.png";